import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    tipSpoils: [],
    listView: false,
    sortBy: "",
    filterBy: "",
    loadingTipSpoils: false
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyTipSpoil', "")
      context.commit('modifyVehicle', "")
      context.commit('modifySite', "")
      context.commit('resetTrips')
    }
  },
  getters: {
    getTipSpoils: state => state.tipSpoils
  }
}